import React from 'react'
import Youtube from './youtube'
import Vimeo from './vimeo'

interface Props {
  url?: string
  className?: string;
  autoplay?: number;
}

function Player(props: Props) {
  const { url, className, autoplay } = props

  let modifiedUrl = url.trim()
  modifiedUrl = modifiedUrl.replace('/www.', '/')

  let iframe = null

  if (/youtube|youtu\.be|i.ytimg\./.test(modifiedUrl)) {
    iframe = <Youtube
      url={url}
      autoplay={autoplay}
    />
  } else if (modifiedUrl.includes('vimeo')) {
    iframe = <Vimeo
      url={url}
      autoplay={autoplay}
    />
  }

  return (
    <div className={className}>
      {iframe}
    </div>
  )
}

export default Player
